

import HomePage from "./views/HomePage";
import ManageUsers from "./views/ManageUsers";
import Login from "./views/Login";
import Logout from "./views/Logout";
import Projects from "./views/Projects";
import CV from "./views/CVPage";
import Blog from "./views/Blog";
import BlogDetailPage from "./views/BlogDetailPage";
import ManageProjectsPage from "./views/ManageProjectsPage";
import ManageBlogEntries from "./views/ManageBlogEntries";
import ManageTechnologyPage from "./views/ManageTechnologyPage";

/**
 * Define the routes of the application.
 */

export const HomePageRoute = {
    url: '/',
    component: HomePage
}

export const ManageUsersRoute = {
    url: '/manage-users',
    component: ManageUsers
}
export const LoginsRoute = {
    url: '/login',
    component: Login
}
export const LogoutsRoute = {
    url: '/logout',
    component: Logout
}
export const ProjectRoutes = {
    url: '/projects',
    component: Projects
}
export const CVRoutes ={
    url: '/cv',
    component: CV
}
export const ProjectDetailRoutes = {
    url: '/projects/:slug',
    component: Projects
}

export const BlogRoutes = {
    url: '/blog',
    component: Blog
}
export const BlogDetailRoutes = {
    url: '/blog/:slug',
    component: BlogDetailPage
}
export const ManageProjectRoutes = {
    url: '/manage-projects',
    component: ManageProjectsPage
}
export const ManageBlogsRoute = {
    url: '/manage-blogs',
    component: ManageBlogEntries
}
export const ManageTechnologyRoutes = {
    url: '/manage-technologies',
    component: ManageTechnologyPage
}


